export const environment = {
  production: false,
  env: 'stg',
  version: 'stg-cc68d3c7',
  feedbackDelay: 5000,
  api: 'https://stg.api.roz.copec.cl',
  googleAnalyticsId: 'G-WZ7RJH83XV',
};
